/* eslint-disable */
import clsx from "clsx";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import {
  CloseIcon,
  Documents,
  DropdownIcon,
  LeftArrowIcon,
  LockIcon,
  ReloadIcon,
  VisibilityOnIcon,
} from "../../assets/Icons";
import Button from "../../components/ui/Button";
import TextField from "../../components/ui/TextField";
import Typograpy from "../../components/ui/Typography";
import { getAdditionalDox, getTransactionSummary } from "../../services/remittance";
import {
  additionalData,
  recipientDetails,
  selectVendor,
  transactionDetails,
  triggerTransactionSummary,
  userAdditionalDocs,
  vendorCodes,
} from "../../store";
import type { Categories } from "../../store/store";
import { getPurposeCode } from "../../utils";
import { customAlert } from "../../utils/CustomAlert";
import { Calculation } from "./Calculation";
import { Modals } from "./Modals";
import { getDocumentList } from "../../services/userDocuments";
import { parseRecipientTransferDocsListResponse } from "../remittance-beta/utils";
import AdditionalDocumentsList from "../../components/ui/DocUpload";
import { uploadAdditionalDocs } from "../../services/kyc";
import { toast, ToastContainer } from "react-toastify";
import { it } from "node:test";
import MixpanelConfig from "../../constants/MixpanelConfig";

export const PurposeCodePage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<string>("start");
  const [taxStep, setTaxStep] = useState<boolean>(true);
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [transactionData, setTransactionData] = useRecoilState(transactionDetails);
  const [purposeCode, setPurposeCode] = useState<string>(transactionData.purposeCode);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [additionalDocData, setAdditionalDocData] = useRecoilState(additionalData);
  const [additionalDocUploaded, setAdditionalDocUploaded] = useRecoilState(userAdditionalDocs);
  const [isDocUploaded, setIsDocUploaded] = useState<boolean>(false);

  const [listOfDocuments, setListOfDocuments] = React.useState<any>();
  const [preViewImage, setPreViewImage] = React.useState("");
  const apiCall = useRecoilValue(triggerTransactionSummary);
  const [loading, setLoading] = useState(false);

  const hasFetchedRef = useRef(false);

  const proceedClass =
    "w-[190px] mt-10 py-3 rounded text-white bg-primary-1050 hover:scale-101 font-semibold";
  const [purposeValue, setPurposeValue] = useState<string>(transactionData?.transaction_purpose);
  const [initialFunctionCall, setInitialFunctionCall] = useState(false);
  const loan = localStorage.getItem("isEducation") || "";
  const tcs = transactionData?.tcs;
  const noDocs = purposeCode === "S1108" || purposeCode === "S1107" || purposeCode === "S0306";
  const [preViewImageSrc, setPreViewImageSrc] = React.useState({
    fileName: "",
    uploadedFile: "",
  });
  const resetAdditionalDocData = useResetRecoilState(additionalData);
  const selectedPurposeValue =
    (transactionData?.transaction_purpose &&
      transactionData?.transaction_purpose.replace(/\s+/g, "-")) ||
    "";

  const [customLoader, setCustomLoader] = React.useState({
    aadhaarOtpLoader: false,
    panLoader: false,
    aadhaarBackLoader: false,
    voterCardLoader: false,
    drivingLoader: false,
    passportBackLoader: false,
    passportFrontLoader: false,
    "Student-Passport": false,
    "Student-Passport Back": false,
    "University-Offer-Letter": false,
    "Rent-Agreement-Invoice": false,
    "Relationship-Proof": false,
    "Recipient-ID": false,
    Recipient_ID: false,
    "Recipient-passport-Driving-license-SSN-number": false,
    "Gift-Declaration": false,
    "Air-Ticket-Copy": false,
    Visa: false,
    "Loan-Sanction-letter": false,
    "Aadhar-Front": false,
    "Aadhar-Back": false,
  });

  useEffect(() => {
    resetAdditionalDocData();
    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      sessionStorage.setItem("navigatingFromPage", "true");
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (initialFunctionCall) {
      getAdditionalDocs();
    }
  }, [initialFunctionCall]);

  useEffect(() => {
    setTimeout(() => {
      const shouldNavigate = sessionStorage.getItem("navigatingFromPage") === "true";
      if (shouldNavigate) {
        sessionStorage.removeItem("navigatingFromPage");
        navigate("/remittance", { replace: true });
      }
    }, 500);
  }, [navigate]);

  const handleProceed = () => {
    setIsDocUploaded(true);
    toast.success("Documents submitted successfully, Directing to review page...");
    MixpanelConfig.trackEvent(MixpanelConfig.eventNames.Old_Documents_Submit, {
      transactionData: transactionData,
    });
    setTimeout(() => {
      navigate("/review");
    }, 1000);
  };

  const isProceed = useMemo(() => {
    let proceed =
      additionalDocData.length > 0 &&
      additionalDocData?.every((item) => (item.isMandatory ? item.isUploaded : true));
    return proceed;
  }, [listOfDocuments, additionalDocData]);

  const vendorCode = useRecoilValue(selectVendor);

  const truncatedText = (originalText: string) => {
    const maxLength = 10;
    return originalText.slice(0, maxLength) + "..." + originalText.slice(-7);
  };

  const idToken = localStorage.getItem("userToken") || "";
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const isEducation: any = localStorage.getItem("isEducation");
  const userId = localStorage.getItem("vendorUserKey") || "";

  const onChangeHandlerType = localStorage.getItem("onChangeHandler") || "send";

  const normalizeCode = (str: string) =>
    str
      ?.trim()
      .replace(/[\s\-_]+/g, "_")
      .replace(/^_+/, "");

  useEffect(() => {
    const body = {
      ...(onChangeHandlerType === "send"
        ? { user_send: transactionData?.user_send ?? 0 }
        : { reciepient_recieve: transactionData?.reciepient_recieve ?? 0 }),
    };
    getTransactionSummary(
      {
        ...body,
        transVendorKey: vendorCode?.userId,
        purposeCode: purposeCode,
        transaction_purpose: purposeValue,
        base_currency: transactionData.base_currency,
        conversion_rate: transactionData.conversion_rate,
        dest_currency: transactionData.dest_currency,
        hop_coins: 0,
        isEducation: isEducation === "true" ? true : false,
        vendor_key: currentUser.vendor_key,
        userId: userId,
        isBene: transactionData.isBene === null ? false : transactionData.isBene,
      },
      idToken
    )
      .then((response) => {
        setTransactionData((prev) => ({
          ...prev,
          ...response?.data,
          transactionLeadIds: {
            ...prev.transactionLeadIds,
            // ...(response?.data?.transactionLeadIds),
          },
        }));
      })
      .catch((error) => {
        console.error(error);
      });
    getDocuments();
    if (noDocs) {
      navigate("/pick-recipient");
    }
  }, [purposeCode]);

  const getAdditionalDocs = () => {
    if (listOfDocuments?.length > 0) {
      getAdditionalDox(purposeCode)
        .then((res) => {
          const updatedList = [...listOfDocuments];
          res?.data?.leadDocList?.forEach((item: any) => {
            let newName = item?.docName
              ?.trim()
              .replace(/[\s\-_]+/g, "_") // Normalize whitespace, hyphens, underscores
              .replace(/^_+|_+$|[^a-zA-Z0-9_]+$/g, "");
            const existingDocIndex = updatedList.findIndex((doc: any) => {
              const normalizedCode = doc?.code
                ?.trim()
                .replace(/[\s\-_]+/g, "_") // Normalize whitespace, hyphens, underscores
                .replace(/^_+|_+$|[^a-zA-Z0-9_]+$/g, ""); // Remove leading/trailing underscores and trailing special chars
              return normalizedCode === newName;
            });
            // setTransactionData(prev => ({
            //   ...prev,
            //   transactionLeadIds: {
            //     ...prev.transactionLeadIds,
            //     [newName]: item?.id
            //   }
            // }));
            const isMandatory = additionalDocData?.some(
              (docData: any) => normalizeCode(docData.code) === newName && docData?.isMandatory
            );
            if (existingDocIndex !== -1) {
              updatedList[existingDocIndex] = {
                ...updatedList[existingDocIndex],
                isUploaded: true,
                uploadedId: item?.id,
                fileName: item?.docName,
                uploadedFile: item?.docUrl,
                // uploadedFile:  URL.createObjectURL(item?.docUrl),
                isMandatory: isMandatory,
              };
            }
          });

          const result: Record<string | number, any> = {};
          updatedList.forEach((item) => {
            const matchedDoc = res?.data?.leadDocList?.find(
              (doc: { docName: string }) => normalizeCode(doc.docName) === normalizeCode(item.code)
            );
            if (matchedDoc) {
              result[item.code] = matchedDoc.id;
            }
          });

          setTransactionData((prev) => ({
            ...prev,
            transactionLeadIds: { ...result },
            // transactionLeadIds: {
            //   ...prev.transactionLeadIds,
            //   [newName]: item?.id
            // }
          }));
          setListOfDocuments(updatedList);
          setAdditionalDocData(updatedList);
        })
        .catch((err) => {
          console.error("Error:", err);
          setTransactionData((prev) => ({
            ...prev,
            transactionLeadIds: {},
          }));
        })
        .finally();
    }
  };

  const handleAdditionalDocUpload = (
    e: { target: { files: any[] } },
    code: string,
    purpose: string,
    id: number
  ) => {
    const fileData = e.target.files[0];
    let data = new FormData();
    data.append("file", fileData);
    const normalized = normalizeCode(code).replace(/`+$/, "");
    setLoading(true);
    uploadAdditionalDocs({ body: data, code: normalized, purpose: purpose })
      .then((response) => {
        if (normalized.replace(/_/g, "-") === "Student-Passport-Front") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            studentPassport: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Student-Passport-Back") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            studentPassportBack: true,
          });
        } else if (normalized.replace(/_/g, "-") === "University-Offer-Letter") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            offerLetter: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Rent-Agreement-Invoice") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            rentNotice: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Relationship-Proof") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            relationProof: true,
          });
        } else if (
          normalized.replace(/_/g, "-") === "Recipient-ID" ||
          normalized.replace(/_/g, "-") === "Beneficiary-ID"
        ) {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            recipientId: true,
          });
        } else if (
          normalized.replace(/_/g, "-") === "Recipient-passport-Driving-license-SSN-number"
        ) {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            recipientPassDLssn: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Gift-Declaration") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            giftDeclaration: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Air-Ticket-Copy") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            airTicket: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Visa") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            visa: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Loan-Sanction-letter") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            loanLetter: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Aadhar-Front") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            aadharFront: true,
          });
        } else if (normalized.replace(/_/g, "-") === "Aadhar-Back") {
          setAdditionalDocUploaded({
            ...additionalDocUploaded,
            aadharBack: true,
          });
        }
        setTransactionData((prev) => ({
          ...prev,
          transactionLeadIds: {
            ...(prev.transactionLeadIds || {}),
            [normalized]: response?.data?.leadDocId,
          },
        }));
        const uploadedData = listOfDocuments.filter((data: any) => {
          return data.code === code;
        })[0];

        const updatedData = {
          ...uploadedData,
          isUploaded: true,
          fileName: fileData.name,
          uploadedId: response?.data?.leadDocId,
          uploadedFile: URL.createObjectURL(e.target.files[0]),
        };

        const updatedList = listOfDocuments.map((doc: any) => {
          if (doc.id === updatedData.id) {
            return { ...updatedData };
          }
          return doc;
        });

        setListOfDocuments(updatedList);
        setAdditionalDocData(updatedList);
        setLoading(false);
      })
      .catch((error) => {
        console.error("ERROR", error);
        toast.error(error?.response?.data?.error?.type);
        setLoading(false);
      });
  };
  const preViewModalHeader = (
    <div className="flex items-center justify-start">
      <div
        className="flex items-center justify-between mr-4 lg:hidden"
        onClick={() => setIsModalOpen("")}
      >
        <LeftArrowIcon />
      </div>
      <div className="items-center justify-between hidden mr-10 lg:flex">
        <Button
          bgColor="bg-primary-450"
          fontStyle={{
            fontFamily: "",
            fontSize: "text-sm",
            fontWeight: "font-medium",
            fontColor: "text-primary",
          }}
          borderStyle={{
            borderRadius: "rounded",
          }}
          className="py-2 px-[18px]"
          onClickHandler={() => setIsModalOpen("")}
        >
          {"<< Go Back"}
        </Button>
      </div>
      <Typograpy
        tagType="div"
        text="Document Preview"
        className="text-black font-normal font-lato text-[32px] mr-[26px] hidden lg:flex"
      />
      <Typograpy
        tagType="div"
        text={preViewImageSrc?.fileName}
        className="text-2xl font-normal text-primary-400 font-lato"
      />
    </div>
  );

  const reciepientType = localStorage.getItem("recipient_type") || "";
  const getDocuments = () => {
    getDocumentList(
      transactionData?.transaction_purpose,
      transactionData?.dest_currency,
      reciepientType,
      localStorage.getItem("isEducation") == "true" ? true : false
    )
      .then((data: any) => {
        let count = -1;
        const parsedDocs = parseRecipientTransferDocsListResponse(data);
        const neededDocs = parsedDocs.map((item) => {
          count++;
          return {
            id: count,
            name: item.displayName,
            code: item.document.replace(/\s+/g, "_"),
            isUploaded: false,
            uploadedId: 0,
            fileName: "",
            isMandatory: item.isRequired,
            uploadedFile: "",
            errorMessage: "",
          };
        });
        setAdditionalDocData(neededDocs as unknown as Categories);
        setListOfDocuments(neededDocs);
        setInitialFunctionCall(true);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  };

  const handleAdditionalDocRemove = (index: number, docType: string, code: any) => {
    const updatedListOfDocs = listOfDocuments.map((file: any) => {
      return file.id === index
        ? { ...file, isUploaded: false, uploadedFile: "", fileName: "" }
        : file;
    });
    setListOfDocuments(updatedListOfDocs);
    setAdditionalDocData(updatedListOfDocs);
    const newLeadIds: { [key: string]: any } = { ...transactionData.transactionLeadIds };
    delete newLeadIds[code as string];
    setTransactionData((prev) => ({
      ...prev,
      transactionLeadIds: newLeadIds,
    }));
  };

  // const handleReset = () => {
  //   const updatedList = listOfDocuments.map((doc: any) => ({
  //     ...doc,
  //     uploadedFile: "",
  //     uploadedId: 0,
  //     fileName: "",
  //     isUploaded: false,
  //   }));

  //   setListOfDocuments(updatedList);
  //   setAdditionalDocData(updatedList);

  //   setTransactionData((prev) => ({
  //     ...prev,
  //     transactionLeadIds: {},
  //   }));
  // };

  return (
    <div className="w-full max-w-[1200px] -mt-10 scale-90">
      <ToastContainer position="top-center" />
      <div className="flex flex-col">
        <div
          id="header"
          // style={{ width: "calc(95vw - 105px)" }}
          className="flex items-start justify-between mr-20"
        >
          <div className="flex flex-col items-start">
            <span className="text-[30px] font-semibold font-ssp">Recipient Documents</span>
            {/* <span className="text-[20px] font-ssp">
              Please upload the required documents for recipient.
            </span> */}
          </div>
          {/* <Button onClickHandler={handleReset} className="flex items-center justify-center gap-2 text-white font-semibold text-sm bg-primary-1050 px-4 py-2 rounded-md hover:bg-primary-1050 transition-all">
            Reset
          </Button> */}
          <Button
            onClickHandler={handleProceed}
            className={`px-16 ml-6 py-4 font-semibold text-white transition-all rounded purpose-code-proceed bg-primary-1050 hover:scale-105 ${
              !isProceed || noDocs ? "cursor-not-allowed opacity-15" : "opacity-100"
            }`}
            disabled={!isProceed || noDocs || loading}
          >
            Submit
          </Button>
        </div>
        <div id="body" className="flex h-screen">
          <div id="left" className="flex flex-col items-start">
            <div className="flex items-end justify-end gap-20 w-full">
              {/* <div
                id="purpose"
                className="h-12 -ml-12 w-fit mt-10 border border-black flex items-center rounded-md p-4 bg-gray-300 text-[14px] justify-between cursor-not-allowed"
              >
                <div>{purposeValue ? purposeValue : "Select Purpose of Payment"}</div>
              </div> */}
              {/* <Button
                onClickHandler={handleProceed}
                className={`px-16 ml-6 mt-10 py-4 font-semibold text-white transition-all rounded purpose-code-proceed bg-primary-1050 hover:scale-105 ${!isProceed || noDocs ? "cursor-not-allowed opacity-15" : "opacity-100"}`}
                disabled={!isProceed || noDocs}
              >
                Submit
              </Button> */}
            </div>
            <div
              className={`flex justify-start my-10 w-full ${
                listOfDocuments?.length > 3 ? "flex-wrap" : "flex-row"
              }`}
            >
              {listOfDocuments &&
                listOfDocuments.map((item: any) => {
                  return (
                    <>
                      <AdditionalDocumentsList
                        data={item}
                        setIsModalOpen={setIsModalOpen}
                        handleUploadAdditionalDocs={handleAdditionalDocUpload}
                        selectedPurposeValue={selectedPurposeValue}
                        handleAdditionalDocRemove={handleAdditionalDocRemove}
                        setPreViewImageSrc={setPreViewImage}
                        index={item.id}
                        buttonLoader={customLoader}
                        key={Math.random()}
                        loading={loading}
                      />
                    </>
                  );
                })}
              <div></div>
            </div>
            {listOfDocuments &&
              (purposeValue === "Personal Gift or Donation" ||
                purposeValue === "Family Maintenance") && (
                <p className="bg-gray-100 p-2 rounded-sm mb-4">
                  <span className="font-semibold">Recipient ID</span> - user can upload any identity
                  document of the recipient. Ex - Passport, foreign driving license, etc
                </p>
              )}
            {listOfDocuments && purposeValue === "Family Maintenance" && (
              <p className="bg-gray-100 p-2 rounded-sm">
                <span className="font-semibold">Relationship proof</span> - user can upload any
                government issued document that shows the relationship with the beneficiary. Ex-
                Passport, Marriage certificate etc.
              </p>
            )}
          </div>
          {/* <div className="border-2 border-gray-300 h-[650px] mt-12"></div>
          <div id="right" className="w-1/2 mt-10">
            <Calculation taxStep={taxStep} setTaxStep={setTaxStep} />
          </div> */}
        </div>
      </div>
      <Modals
        isModalOpen={isModalOpen}
        purposeCode={purposeCode}
        setIsModalOpen={setIsModalOpen}
        setPurposeCode={setPurposeCode}
        setPurposeValue={setPurposeValue}
        preViewModalHeader={preViewModalHeader}
        preViewImageSrc={preViewImage}
      />
    </div>
  );
};
